import { useLocation } from "react-router-dom";
import iconNotice from "../../../assets/icon_notice.svg";
import { parse, differenceInDays } from "date-fns";
import InfiniteScroll from "react-infinite-scroll-component";
import useReactGASend from "../../../hooks/useReactGASend";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const NoticeItem = ({
  id,
  title,
  created_at,
  priority,
  index,
  listLength,
  handleClick,
  color,
}) => {
  // 날짜 비교 함수
  const isNew = (createdAt) => {
    const now = new Date();
    const createdDate = parse(createdAt, "yyyy.MM.dd", new Date());
    const diffDays = differenceInDays(now, createdDate);
    return diffDays <= 7;
  };

  const { makeEventTrackFn } = useReactGASend();
  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: `공지사항_${title}`,
    });
  };

  return (
    <li
      className="flex items-start gap-4"
      role="button"
      key={id}
      onClick={() => {
        handleClick(id);
        trackLinkClick(title);
      }}
    >
      <div className="flex items-center justify-center text-sm font-medium leading-relaxed shrink-0 w-7 h-7">
        {priority ? (
          <img src={iconNotice} alt="Notice Icon" />
        ) : (
          listLength - index
        )}
      </div>
      <div className="relative flex flex-col flex-1 gap-3 pb-4 border-b">
        <p
          className={`text-lg leading-relaxed break-word ${
            priority ? "font-bold" : "font-medium"
          }`}
        >
          {title}
          {isNew(created_at) && (
            <span
              className={`inline-block ml-2 py-1 px-3 text-center text-xs font-medium align-middle bg-${color} rounded-full`}
            >
              N
            </span>
          )}
        </p>
        <p className="text-sm font-semibold leading-tight text-neutral-400">
          {created_at}
        </p>
      </div>
    </li>
  );
};

const NoticeList = ({ noticeList, fetchMoreData, infinity, setListId }) => {
  const location = useLocation();

  const { color } = useSelectBrand();

  const handleClick = (id) => {
    setListId(id);
    window.history.pushState(null, "", location.pathname);

    const handlePopState = () => {
      setListId(null);
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  };

  return (
    <div className="mt-10">
      <InfiniteScroll
        dataLength={noticeList?.length}
        next={fetchMoreData}
        hasMore={infinity}
      >
        <ul className="flex flex-col gap-y-4">
          {noticeList.map((notice, index) => (
            <NoticeItem
              key={notice.id}
              id={notice.id}
              title={notice?.title}
              created_at={notice?.created_at}
              priority={notice?.priority}
              index={index}
              listLength={noticeList?.length}
              handleClick={handleClick}
              color={color}
            />
          ))}
        </ul>
      </InfiniteScroll>
    </div>
  );
};

export default NoticeList;
